import React from 'react';
import DateRangeFilter from 'components/list/Filters/types/DateRangeFilter';

const CreatedAtFilter = <DateRangeFilter
    floatingLabelFixed={ true }
    fullWidth={ true }
    label='filters.components.createdAt.label'
    placeholder='filters.components.createdAt.placeholder'
    source='created_at'
/>;

export default CreatedAtFilter;



// WEBPACK FOOTER //
// ./src/components/form/filters/CreatedAtFilter.js